(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/winplan.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/winplan.js');


'use strict';

svs.numbergames.game.views.WinPlan = Marionette.View.extend({
  viewOptions: ['collapsableBreakpoint', 'collapsedToggleWidth', 'footerText', 'multipliedRowPrice'],
  collapsableBreakpoint: 1024,
  isCollapsed: true,
  regions: {
    winplanHeaderRegion: '#winplanHeaderRegion',
    winplanTableRegion: '#WinplanTableRegion'
  },
  ui: {
    winplanInner: '.js-winplan-inner',
    header: '.js-winplan-header',
    headerInner: '.js-winplan-header-inner',
    body: '.js-winplan-body',
    bodyInner: '.js-winplan-body-inner'
  },
  triggers: {
    'click @ui.winplanInner': 'toggleWinplan'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-winplan numbergames-winplan-".concat(brandingSuffix, " relative");
  },
  modelEvents: {
    'change:level change:hasKungKeno': 'onModelUpdate',
    'change:isValid': 'onSystemModelUpdate'
  },
  template: data => svs.numbergames.game.templates.winplan(data),
  initialize() {
    svs.numbergames.game.logger.debug('svs.numbergames.game.views.WinPlan initialized');
    this.mergeOptions(this.options, this.viewOptions);
    this.onToggleWinplan = this.onToggleWinplan.bind(this);
    this.winplanAttentionAnimThrottled = _.throttle(() => this.winplanAttentionAnim(), 400);
    this.setIsCollapseable = this.setIsCollapseable.bind(this);
    window.addEventListener('resize', this.setIsCollapseable);
  },
  onRender() {
    this.showChildView('winplanHeaderRegion', new svs.numbergames.game.views.WinPlanHeader({
      model: this.model,
      multipliedRowPrice: this.multipliedRowPrice
    }));
    this.showChildView('winplanTableRegion', new svs.numbergames.game.views.WinPlanTable({
      model: this.model,
      multipliedRowPrice: this.multipliedRowPrice
    }));
  },
  onAttach() {
    this.toggleAnimation = this.createToggleAnim();
    this.setIsCollapseable();
  },
  onToggleWinplan() {
    if (this.isCollapsed) {
      this.isCollapsed = false;
      this.$el.removeClass('winplan-collapsed');
      this.toggleAnimation.reverse();
    } else {
      this.isCollapsed = true;
      this.$el.addClass('winplan-collapsed');
      this.toggleAnimation.play();
    }
  },
  onChangeRowPriceMulti(multipliedRowPrice) {
    this.getChildView('winplanHeaderRegion').triggerMethod('changeRowPriceMulti', multipliedRowPrice);
    this.getChildView('winplanTableRegion').triggerMethod('changeRowPriceMulti', multipliedRowPrice);
  },
  onModelUpdate() {
    this.winplanAttentionAnimThrottled();
  },
  onSystemModelUpdate() {
    this.model.get('isSystem') && this.winplanAttentionAnimThrottled();
  },
  setIsCollapseable() {
    const wasCollapseable = this.isCollapseable;
    this.isCollapseable = window.innerWidth < this.collapsableBreakpoint;
    if (this.isCollapseable === wasCollapseable) {
      return;
    }
    if (this.isCollapseable) {
      this.isCollapsed = true;
      this.$el.addClass('winplan-with-toggling winplan-collapsed');
      this.toggleAnimation.progress(1);
    } else {
      this.isCollapsed = false;
      this.$el.removeClass('winplan-with-toggling winplan-collapsed');
      this.toggleAnimation.pause();
      this.toggleAnimation.progress(0);
      const resetElements = [this.getUI('header'), this.getUI('headerInner'), this.getUI('body')];
      gsap.set(resetElements, {
        clearProps: 'all'
      });
    }
  },

  createToggleAnim() {
    const bodyDelayOverlap = 0;
    const headerMinHeight = 24;
    const headerTextMinHeight = 18;
    const animation = gsap.timeline({
      paused: true
    });
    animation.to(this.getUI('body'), {
      height: 0,
      duration: 0.15
    }, bodyDelayOverlap);
    animation.set(this.getUI('header'), {
      clearProps: 'width'
    });
    animation.to(this.getUI('headerInner'), {
      height: headerTextMinHeight,
      duration: 0.1
    }, '-=0.2');
    animation.to(this.getUI('header'), {
      height: headerMinHeight,
      duration: 0.2
    }, '-=0.2');
    animation.to(this.getUI('header'), {
      width: this.collapsedToggleWidth,
      duration: 0.1
    });
    animation.to(this.getUI('header'), {
      borderRadius: '0 0 4px 4px',
      duration: 0.1
    });
    return animation;
  },
  winplanAttentionAnim() {
    if (this.isCollapseable && this.isCollapsed) {
      const max = 5;
      const min = -5;
      const speed = 0.1;
      gsap.to(this.el, speed, {
        x: max
      });
      gsap.to(this.el, speed, {
        x: min,
        delay: speed
      });
      gsap.to(this.el, speed, {
        x: max,
        delay: speed * 2
      });
      gsap.to(this.el, speed, {
        x: min,
        delay: speed * 3
      });
      gsap.to(this.el, speed, {
        x: 0,
        delay: speed * 4
      });
    }
  },
  onDestroy() {
    window.removeEventListener('resize', this.setIsCollapseable);
  }
});

 })(window);